// components/InventoryList.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from "axios";
import { useMessage } from '../contexts/MessageContext';

const apiUrl = window._env_?.REACT_APP_API_URL || "https://app.mylocaleventrentals.com/api";

const AccountsNew = () => {
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [type, setType] = useState('Asset'); // default type
  const [parentId, setParentId] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { showError, showSuccess } = useMessage();
  
  const { logout } = useAuth();
  const navigate = useNavigate();

  // Fetch accounts for parent selection
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      logout();
      navigate('/login');
      return;
    }

    const fetchAccounts = async () => {
      try {
        const res = await axios.get(`${apiUrl}/account/tree`, {
          headers: { 'x-auth-token': token }
        });
        setAccounts(res.data.data);
      } catch (err) {
        console.error(err);
        showError('Failed to load accounts');
      }
    };
    fetchAccounts();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const token = localStorage.getItem('token');
    if (!token) {
      logout();
      navigate('/login');
      return;
    }

    try {
      const res = await axios.post(`${apiUrl}/account`, {
        name,
        code,
        type,
        parent_id: parentId || null,
      }, {
        headers: { 'x-auth-token': token }
      });

      showSuccess('Account created successfully!');
      setName('');
      setCode('');
      setType('Asset');
      setParentId('');
      // Optionally refresh accounts list
      setAccounts(prev => [...prev, res.data]);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Failed to create account');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='p-6 bg-white rounded shadow'>
      <h3 className='text-xl font-bold mb-4'>Create New Account</h3>

      {error && <p className='text-red-500 mb-2'>{error}</p>}

      <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
        <div>
          <label className='block mb-1'>Account Name</label>
          <input
            type='text'
            value={name}
            onChange={(e) => setName(e.target.value)}
            className='w-full border p-2 rounded'
            required
          />
        </div>

        <div>
          <label className='block mb-1'>Account Code</label>
          <input
            type='text'
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className='w-full border p-2 rounded'
            required
          />
        </div>

        <div>
          <label className='block mb-1'>Type</label>
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className='w-full border p-2 rounded'
          >
            <option value='Asset'>Asset</option>
            <option value='Liability'>Liability</option>
            <option value='Equity'>Equity</option>
            <option value='Revenue'>Revenue</option>
            <option value='Expense'>Expense</option>
          </select>
        </div>

        <div>
          <label className='block mb-1'>Parent Account (optional)</label>
          <select
            value={parentId}
            onChange={(e) => setParentId(e.target.value)}
            className='w-full border p-2 rounded'
          >
            <option value=''>-- None --</option>
            {accounts.map(acc => (
              <option key={acc.uuid} value={acc.uuid}>
                {acc.name} ({acc.code})
              </option>
            ))}
          </select>
        </div>

        <button
          type='submit'
          className='bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700'
          disabled={loading}
        >
          {loading ? 'Creating...' : 'Create Account'}
        </button>
      </form>
    </div>
  );
};

export default AccountsNew;